import { Button } from '@carvana/helios-navigation/button';
import { breakpoint } from '@carvana/helios-styles';
import Image from 'next/image';

import { APP_BASE_PATH } from '../../../shared/appBasePath';
import howitworkspic from '../../../../public/images/how-it-works.webp';
import useAnalyticEvent, { PageName } from '../../../hooks/useAnalyticEvent';

import {
  Container,
  Wrapper,
  ContentWrapper,
  Number,
  Line,
  ImageWrapper,
  ImageStyle,
  Section,
  FigurePart,
  TextPart,
  Title,
  SubTitle,
  Description,
  ButtonWrapper
} from './HowItWorks.styles';

const HowItWorks = () => {
  const { recordEventAndNavigateTo } = useAnalyticEvent();

  const handleClick = () => {
    recordEventAndNavigateTo(
      `${APP_BASE_PATH}/get-value/vehicle`,
      PageName.Marketing,
      'How It Works'
    );
  };

  return (
    <Container>
      <Wrapper>
        <Title>How it works</Title>
        <ContentWrapper>
          <Section>
            <FigurePart>
              <Number left="22px" right="22px">
                1
              </Number>
              <Line />
            </FigurePart>
            <TextPart>
              <SubTitle>Input vehicle details</SubTitle>
              <Description>
                Share your vehicle's history, a few key details and we’ll provide a real value in
                minutes.
              </Description>
            </TextPart>
          </Section>
          <Section>
            <FigurePart>
              <Number left="21px" right="21px">
                2
              </Number>
              <Line />
            </FigurePart>
            <TextPart>
              <SubTitle>Get access to your Value Tracker report</SubTitle>
              <Description>
                Receive a robust report that outlines key details about your car’s current and
                historical value, plus automotive market trends.
              </Description>
            </TextPart>
          </Section>
          <Section>
            <FigurePart>
              <Number left="20px" right="20px">
                3
              </Number>
            </FigurePart>
            <TextPart>
              <SubTitle>Set your preferences</SubTitle>
              <Description>
                Stay up to speed on your value via email, at a frequency you decide.
              </Description>
            </TextPart>
          </Section>
          <ButtonWrapper>
            <Button size="lg" variant="primary" onClick={handleClick}>
              Track My Value
            </Button>
          </ButtonWrapper>
        </ContentWrapper>
        <ImageWrapper>
          <Image
            src={howitworkspic}
            alt="How It Works"
            style={ImageStyle}
            fill
            sizes={`(max-width: ${breakpoint.md}) 100vw,
              (max-width: ${breakpoint.sm}) 80vw,
              33vw`}
          />
        </ImageWrapper>
      </Wrapper>
    </Container>
  );
};

export default HowItWorks;
